import styled from 'styled-components';
import { Layout } from 'antd';
import { AA_SURFACE } from '~/modules/Helper/contrast.helper';
import {
  HEADER_BANNER_CHIP,
  headerBannerChipBase,
} from './headerBannerChip.styled';

const recuoMenu = `${HEADER_BANNER_CHIP.tamanho +
  HEADER_BANNER_CHIP.borda +
  12}px`;
const recuoAcessibilidade = `${32 * 4 +
  8 * 3 +
  12 +
  HEADER_BANNER_CHIP.borda}px`;

/**
 * Botão de abrir o menu no banner (mobile): canto superior esquerdo.
 */
export const HeaderLeftBar = styled.div`
  ${headerBannerChipBase}
  left: 0;
  width: ${HEADER_BANNER_CHIP.tamanho}px;
  min-width: ${HEADER_BANNER_CHIP.tamanho}px;
  height: ${HEADER_BANNER_CHIP.tamanho}px;
  flex-shrink: 0;
  border-right-width: ${HEADER_BANNER_CHIP.borda}px;
  border-bottom-width: ${HEADER_BANNER_CHIP.borda}px;
  border-radius: 0 0 ${HEADER_BANNER_CHIP.raio}px 0;
`;

export const HeaderTitleSlot = styled.div`
  min-width: 0;
`;

/**
 * Grupo de acessibilidade: mesmo chip do menu, canto superior direito.
 */
export const HeaderAcessibilitySlot = styled.div`
  ${headerBannerChipBase}
  right: 0;
  left: auto;
  flex-wrap: nowrap;
  flex-shrink: 0;
  padding: 0 6px;
  max-width: calc(100% - ${recuoMenu});
  white-space: nowrap;
  border-left-width: ${HEADER_BANNER_CHIP.borda}px;
  border-bottom-width: ${HEADER_BANNER_CHIP.borda}px;
  border-radius: 0 0 0 ${HEADER_BANNER_CHIP.raio}px;

  button {
    background: transparent !important;
    color: inherit;
    border: none;
    box-shadow: none;
    width: 32px;
    min-width: 32px;
    height: 32px;
    border-radius: 4px;
  }

  button:hover,
  button:focus {
    background: rgba(255, 255, 255, 0.12) !important;
    color: ${AA_SURFACE};
  }

  button:disabled {
    opacity: 0.55;
  }
`;

export const Header = styled(Layout.Header)`
  && {
    position: relative;
    isolation: isolate;
    overflow: visible !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 160px;
    min-height: 160px;
    line-height: 1;
    background-color: #fff;
    background-image: url(${({ src }) => `'${src}'`});
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    padding: 0 !important;
  }

  && > ${HeaderLeftBar} {
    top: 0 !important;
    left: 0 !important;
    margin: 0 !important;
  }

  && > ${HeaderAcessibilitySlot} {
    top: 0 !important;
    right: 0 !important;
    margin: 0 !important;
  }

  && > ${HeaderTitleSlot} {
    padding: 12px ${recuoAcessibilidade} 12px
      ${({ $hasLeftBar }) => ($hasLeftBar ? recuoMenu : '16px')};
  }

  @media (max-width: 480px) {
    && {
      justify-content: center;
      height: auto;
      min-height: 120px;
    }

    && > ${HeaderTitleSlot} {
      display: block;
      width: 100%;
      margin: 0;
      font-size: 1.2rem;
      padding-top: ${recuoMenu};
    }
  }
`;
